import { useQuery } from '@tanstack/react-query';

import { CLIENTS_COPY } from '@/features/reports/copy';
import { relationshipManagersQuery } from '@/features/users/queries';

/**
 * A relationship manager's name as the page's filter shows it (ALS-160), or by id for one in the
 * address who is no longer one; nothing when every manager is chosen.
 */
export function useManagerName(rmId: number | undefined): string | undefined {
    const managers = useQuery(relationshipManagersQuery);
    if (rmId === undefined) return undefined;
    return managers.data?.find((m) => m.id === rmId)?.name ?? `${CLIENTS_COPY.rm.label} ${rmId}`;
}
